import React, { useEffect, useRef, useState } from "react";
import MessageInput from "./MessageInput";

const ChatWindow = ({
  selectedContact,
  handleSendMessage,
  message,
  setMessage,
  contactMessages,
  lastReceivedMessage,
}) => {
  const [sentMessages, setSentMessages] = useState([]);
  const messagesContainerRef = useRef(null);

  // Scrolla in fondo quando cambiano i messaggi o il contatto selezionato
  useEffect(() => {
    scrollToBottom();
  }, [selectedContact, contactMessages]);

  const scrollToBottom = () => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  };

  // Funzione per inviare un messaggio
  const handleSend = (message) => {
    // Aggiungi il messaggio alla lista dei messaggi inviati
    setSentMessages((prevMessages) => [...prevMessages, message.text]);

    // Chiamare la funzione handleSendMessage che è passata come props
    handleSendMessage({ text: message.text, sender: "sent" });
  };

  const messages = selectedContact
    ? contactMessages[selectedContact.id] || []
    : [];
  const lastMessage = selectedContact ? selectedContact.lastMessage : "";

  return (
    <div
      className={`chat-window animated`}
    >
      {selectedContact ? (
        <div className="messages-page">
          <div className="messages-page-header">
            <img
              alt="selectedContact.name"
              className="contact-avatar"
              src={selectedContact.avatar}
            />
            <h2 className="contact-name animated">{selectedContact.name}</h2>
          </div>

          {/* Contenitore dei messaggi */}
          <div className="messages-container animated" ref={messagesContainerRef}>
            {lastMessage && (
              <div className="message contact-last-message">{lastMessage}</div>
            )}

            {messages.map((message, index) => (
              <div
                key={index}
                className={`message ${message.sender} ${
                  sentMessages.includes(message.text) ? "animated" : ""
                }`} // Aggiungi la classe fade-in solo ai nuovi messaggi
              >
                {message.text}
              </div>
            ))}
          </div>

          {lastReceivedMessage && (
            <div className="last-message received-message">
              {lastReceivedMessage}
            </div>
          )}

          <MessageInput
            handleSendMessage={handleSend}
            message={message}
            setMessage={setMessage}
          />
        </div>
      ) : (
        <div className="no-chat-selected">No chat selected</div>
      )}
    </div>
  );
};

export default ChatWindow;
